<div class="run-demo">
  <div class="run-demo-bar">
    <div class="run-demo-bar__copy">
      <p class="run-demo-kicker">UI harness — no API, seats, or SignalR</p>
      <h1>Webinar run demo</h1>
      <p>Now: <strong>{{ currentPhase.label }}</strong> ({{ dto?.status }})</p>
    </div>
    <div class="run-demo-bar__actions">
      <button type="button" class="run-demo-btn" (click)="restart()">Restart</button>
      <button type="button" class="run-demo-btn" (click)="back()" [disabled]="phaseIndex === 0">Back</button>
      <button type="button" class="run-demo-btn run-demo-btn--primary" (click)="next()" [disabled]="phaseIndex === phases.length - 1">Next</button>
      <button type="button" class="run-demo-btn" (click)="toggleAutoPlay()">
        {{ autoPlay ? 'Pause auto' : 'Resume auto' }}
      </button>
    </div>
    <div class="run-demo-phases" role="tablist">
      <button
        type="button"
        class="run-demo-phase"
        *ngFor="let phase of phases; let i = index"
        [class.is-active]="i === phaseIndex"
        (click)="goTo(i)">
        {{ i + 1 }}. {{ phase.label }}
      </button>
    </div>
  </div>

  <div *ngIf="dto">
    <div class="row" *ngIf="dto.status !== 'Completed'">
      <div class="col-12">
        <div *ngIf="dto.status == 'Not Started' || dto.status == 'Started'">
          <app-webinar-countdown
            [webinarName]="dto.webinarName"
            [secondsToStart]="dto.secondsToStart"
            [startAt]="dto.webinarStartDateTime"
            [serverNow]="dto.currentDateTime"
            (remainingSecondsChange)="countdownRemaining = $event"></app-webinar-countdown>
        </div>
        <div *ngIf="keepRunPlayer">
          <app-play-video
            [videoUrl]="runVideoUrl"
            [shouldPlay]="isVideoPlayingPhase"
            [isMobileView]="isMobileView"
            [posterUrl]="dto.itemImageUrl"
            [fileExtension]="dto.fileExtention"></app-play-video>
        </div>
      </div>
    </div>
    <div class="row seats-row">
      <div class="col-12 col-lg-8 seats-column">
        <div *ngIf="displaySeats">
          <app-user-seat
            *ngFor="let gridKey of [seatGridKey]"
            [seats]="dto.userSeats"
            [selectedSeat]="winnerSeatNumber"
            [webinarName]="dto.webinarName"
            [displaySeatsDelaySeconds]="dto.seatsDisplayDelaySeconds"
            (introScrollComplete)="onSeatIntroScrollComplete()"></app-user-seat>
        </div>
      </div>
      <div id="resultsSection" class="col-12 col-lg-4 flex results-column" *ngIf="shouldShowResultsPanel()">
        <app-display-results
          *ngFor="let phaseStatus of [dto.status]"
          [webinarRun]="dto"
          [status]="phaseStatus"
          (congrtsPopup)="openCongratsPopup($event)"></app-display-results>
      </div>
    </div>
  </div>
</div>
